export const NavigationKey = {
  ProjectInformation: "information",
  InvoicingSettings: "invoicing",
  Members: "members",
  ProjectCategories: "categories",
};
